import { IBaseAction } from '../../constants';
import { Flight } from '../FlightRequestDetails/types';

export interface FlightRequestHistory {
    type: string;
    airline: string;
    flights: Flight[];
    generatedFlights: Flight[];
    monitoringNumber?: string;
    status: string;
    instanceId: string;
    taskId: string;
    monitoringNumberFile?: string;
    rejectionDescription?: string;
    reasonsOfRejection?: string[];
    candidateGroup: string;
    updatedAt?: Date;
    requesterName?: string;
    airlineLogo: string;
    flightRequestId: string;
}

export interface FlightRequestHistoryListState {
    data: FlightRequestHistory[];
    total: 0;
}

export interface FlightRequestHistoryInfoInitialState {
    flightRequestHistories: Array<FlightRequestHistory>;
}
export const GET_FLIGHT_REQUEST_HISTORY = 'GET_FLIGHT_REQUEST_HISTORY';
export const GET_FLIGHT_REQUEST_HISTORY_SUCCESS = 'GET_FLIGHT_REQUEST_HISTORY_SUCCESS';
export const GET_FLIGHT_REQUEST_HISTORY_CLEAR = 'GET_FLIGHT_REQUEST_HISTORY_CLEAR';
interface GetFlightRequestHistoriesList extends IBaseAction {
    type:
        | typeof GET_FLIGHT_REQUEST_HISTORY
        | typeof GET_FLIGHT_REQUEST_HISTORY_SUCCESS
        | typeof GET_FLIGHT_REQUEST_HISTORY_CLEAR;
    payload?: {
        data: FlightRequestHistoryInfoInitialState;
    };
}

export type GetFlightRequestHistoryActionTypes = GetFlightRequestHistoriesList;
